import { useLingui } from '@lingui/react/macro';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import UrlInput from 'ud-ui/components/url-input/url-input';
import { GameDetails } from 'modules/games/domain/interfaces/game-details';
import { changeGameDetailsVideoUrl } from 'modules/games/store/actions';

interface IProps {
  isLoading: boolean;
  game: GameDetails | null;
}

function MainStreamURL(props: IProps) {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useLingui();

  const { isLoading, game } = props;
  const videoUrl = useMemo(() => (game?.videoUrls.length ? game.videoUrls[0] : ''), [game]);
  const handleVideoUrlChanged = useCallback(
    (url: string) => {
      dispatch(changeGameDetailsVideoUrl(url));
    },
    [dispatch],
  );

  return (
    <UrlInput
      isLoading={isLoading}
      value={videoUrl}
      onChange={handleVideoUrlChanged}
      name="videoUrl"
      placeholder={t`Ссылка на трансляцию`}
      style={{ marginBlock: 16 }}
    />
  );
}

export default MainStreamURL;
